import { render, staticRenderFns } from "./Pmi.vue?vue&type=template&id=cdc50dec"
import script from "./Pmi.vue?vue&type=script&lang=js"
export * from "./Pmi.vue?vue&type=script&lang=js"
import style0 from "./Pmi.vue?vue&type=style&index=0&id=cdc50dec&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports